import React, { Component } from 'react'
import { Label, Card, Divider, Segment, Input, Button, Message, Modal} from 'semantic-ui-react';
// import Chart from '../components/chart'
import '../App.css'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';
import { toast } from 'react-toastify';
require('moment-timezone');
var moment = require('moment');

/*
    This compoenent is responsibel for redering all currently available nodes information (new and old) in the system.
    This is rendered in the Network Settings Page under Advanced Device configurations.
    This page is used to edit details for each nodes such as Node Id, Forest Name, VWC 60 threshold etc.
*/
class Node extends Component {
    constructor(props){
        super(props);
        this.state = {
            isView:true,
            toggleBtn:false,
            isLoading:false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }

    handleChange(e, data){
        e.preventDefault();
        let id  = data.id;
        if(id === "editToggle"){
            this.setState({isView:!this.state.isView, toggleBtn:!this.state.toggleBtn} , ()=>{
            })
        }

        if(id === "forest_name"){
            this.setState({forest_name:data.value})
        }
        
        if(id === "node_num"){
            this.setState({node_num:parseInt(data.value, 10)})
        }
        if(id === "forest_id"){
            this.setState({forest_num:data.value})
        }
        if(id === "lat_lng"){
            let str = data.value;
            str = str.replace(" ", "");
            let latlang = str.split(",")
            let parsedLatLng = latlang.map(i =>{
                return parseFloat(i)
            })

            this.setState({lat_lng:parsedLatLng})
        }
        if(id === "vwc30_low"){
            this.setState({vwc30_low:parseFloat(data.value)})
        }
        if(id === "vwc30_mid"){
            this.setState({vwc30_mid:parseFloat(data.value)})
        }
        if(id === "vwc30_high"){
            this.setState({vwc30_high:parseFloat(data.value)})
        }
        if(id === "vwc60_low"){
            this.setState({vwc60_low:parseFloat(data.value)})
        }
        if(id === "vwc60_mid"){
            this.setState({vwc60_mid:parseFloat(data.value)})
        }
        if(id === "vwc60_high"){
            this.setState({vwc60_high:parseFloat(data.value)})
        }
        if(id === "forest_boundry"){
            this.setState({forest_boundry:(data.value)})
        }


    }
    handleEdit(e, data){
        e.preventDefault();
        let nodedata ={}
        
        // prepare the new payload. if the data fieds are empty  use the exsitging data. 
        try{
            nodedata['forest_name'] = this.state.forest_name || this.props.selfNode['forest_name'];
            nodedata['forest_num'] =  this.state.forest_num || this.props.selfNode['forest_num'];
            nodedata['lat_lng'] = this.state.lat_lng || this.props.selfNode['lat_lng'];
            nodedata['node_num'] = this.state.node_num || this.props.selfNode['node_num']
            nodedata['vwc30_low']  = this.state.vwc30_low || this.props.selfNode['vwc30_low'];
            nodedata['vwc30_mid'] = this.state.vwc30_mid || this.props.selfNode['vwc30_mid'];
            nodedata['vwc30_high']  = this.state.vwc30_high || this.props.selfNode['vwc30_high'];
            nodedata['vwc60_low'] = this.state.vwc60_low || this.props.selfNode['vwc60_low'];
            nodedata['vwc60_mid'] = this.state.vwc60_mid || this.props.selfNode['vwc60_mid'];
            nodedata['vwc60_high'] = this.state.vwc60_high || this.props.selfNode['vwc60_high'];
            nodedata['active_since'] = this.props.selfNode['active_since'] || moment().unix()
            nodedata['forest_boundry'] = this.state.forest_boundry || this.props.selfNode['forest_boundry'];
        } catch(e){
            toast.error("The form is invalid. Please enter the data in the correcct format shown!")
            return;
        }
        if(nodedata['lat_lng'].length === 2){
            let error = false;
            nodedata['lat_lng'].forEach(i =>{
                if( isNaN(i) || i === "NaN"){
                    error = true;
                    toast.error("Coordinates invalid! Please enter coordinates in the format shown!")
                } else{
                }
            })
            if(error === false){
                toast.info("Saving new node configuration..")
                this.setState({isView:true});
                this.props.tokenActions.editNode(this.props.userId, this.props.organisation, this.props.selfNodeId, nodedata);
            }
            
            
            // this.props.tokenActions.editNode(this.props.userId, this.props.org, this.props.nodeId, nodedata);
            // return;
        } else{
            toast.error("Coordinates invalid! Please enter coordinates in the format shown!")
        }


        
        // this.props.tokenActions.editNode(this.props.userId, this.props.org, this.props.nodeId, nodedata);

    }
    componentWillReceiveProps(props){
        console.log(props)
        if(props.addNodeSuccess === true){
            toast.success("Node Added Successully")
        }
        if(props.addNodeSuccess === false){
            toast.error("Error. Could not add Node!")
        }
        if(props.editNodeSuccess === true){
            toast.success("Changes applied successully!")
        } 
        if(props.editNodeSuccess === false){
            toast.error("Error. Could not apply new changes")
        }

        // this.props.tokenActions.hideAlerts();
    }


    render(){
        const cardDStyle = {
            "minHeight":"100%",
            "paddingTop":"",
            // "marginLeft":"1px",
            minWidth:"50%"
        }
        const ribbons = {
            float:"left"
        }
        return(
            <div className = "eight wide column" >          
            <Segment style={cardDStyle} >
                <Card.Content>
                    {this.state.isView ? 
                        <Button  style={{marginTop:'3px', float:'right'}} secondary size ={'mini'} id ='editToggle' icon ="edit" onClick={this.handleChange} content = {'Edit Configuration'}/>
                        :
                        <Button  style={{marginTop:'3px', float:'right'}} negative size ={'mini'} id ='editToggle' icon="cancel" onClick={this.handleChange} content = {'Abort'}/>
                    }
                
                <Label as='a' color={'orange'} ribbon style={ribbons}>
                                Node: {this.props.selfNode['node_num']}
                </Label>
                    <p><strong>Unique Node ID </strong> <Card.Meta>{this.props.selfNodeId}</Card.Meta></p>
                    <br/>
                        {this.props.selfNode['active_since'] && 
                            <Card.Description>
                                    Active Since
                                    <Label style={{width :'100%'}} id="node_active_since">
                                        {moment(this.props.selfNode['active_since'] * 1000).format('DD/MM/YY HH:mm:ss')}  
                                        </Label>
                            </Card.Description>
                        }
                    <br/>
                    <Card.Description>
                            Node / Device Number 
                            <Input disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={this.props.selfNode['node_num']}  id="node_num"/>
                    </Card.Description>


                    <Card.Description>
                            Forest 
                            <Input disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={this.props.selfNode['forest_name']}  id="forest_name"/>
                    </Card.Description>
                    <Card.Description>
                            Forest ID 
                            <Input disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={this.props.selfNode['forest_num']}  id="forest_id"/>
                    </Card.Description>
                    <Card.Description>
                            Coordinates
                            <Input disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={this.props.selfNode['lat_lng']}  id="lat_lng"/>
                    </Card.Description>
                    <Card.Description>
                            Forest Boundry
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder={this.props.selfNode['forest_boundry']}  id="forest_boundry">
                            </Input>
                        </Card.Description>
                    
                    <Segment raised style ={{
                           "borderBottomStyle":"solid",
                           "borderBottomtWidth":"1px",
                           "borderBottomColor":"orange",
                           "overflow":"hidden"
                            }}>
                        <h4>VWC Thresholds for Heatmap</h4>
                            <Button.Group  size='large' style={{maxWidth:"100%"}}>
                                <Button style={{background:"#9b382b", color:"white"}}>Dry</Button>
                                <Button style={{background:"#003f00", color:"white"}}>Normal</Button>
                                <Button style={{background:"#0d3ab1", color:"white"}}>Wet</Button>
                                <Button style={{background:"#00ffff", color:"white"}}>Very Wet</Button>
                            </Button.Group>
                            <Divider/>
                        {/* <Card.Description>
                            VWC 30 Low 
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={this.props.selfNode['vwc30_low']} id="vwc30_low">
                            <input />
                            <Label inverted>%</Label>
                            </Input>
                        </Card.Description>
                        <Card.Description>
                            VWC 30 Mid  
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder ={this.props.selfNode['vwc30_mid']} id="vwc30_mid">
                                <input />
                                <Label>%</Label>
                            </Input>
                        </Card.Description>
                        <Card.Description>
                            VWC 30 High 
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder={this.props.selfNode['vwc30_high']}  id="vwc30_high">
                            <input />
                            <Label>%</Label>
                            </Input>
                        </Card.Description> */}
                        <Card.Description>
                            VWC 60 Dry  - (Below threshold is dry. Above threshold is normal) 
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder={this.props.selfNode['vwc60_low']}  id="vwc60_low">
                            <input />
                            <Label>%</Label>
                            </Input>
                        </Card.Description>
                        <Card.Description>
                            VWC 60  Wet  - (Below threshold is normal. Above threshold is wet)
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder={this.props.selfNode['vwc60_mid']}  id="vwc60_mid">
                            <input />
                            <Label>%</Label>
                            </Input>
                        </Card.Description>
                        <Card.Description>
                            VWC 60 Very Wet  - (Below threshold is wet. Above threshold is very wet)
                            <Input labelPosition='right' type='text' disabled ={this.state.isView} style={{width :'100%'}}  onChange = {this.handleChange} placeholder={this.props.selfNode['vwc60_high']}  id="vwc60_high">
                            <input />
                            <Label>%</Label>
                            </Input>
                        </Card.Description>

                    </Segment>
                    <Divider/>
                     <Message info floating hidden ={this.state.isView} size={'tiny'}>

                        <Message.Header>Only fill in the fields you wish to change</Message.Header>
                        <p>Rest of the data will be saved as is.</p>

                     </Message>           
                    </Card.Content>
                    <Modal  trigger={<Button inverted style={{marginTop:'3px', marginBottom:'10px', float:'right'}} disabled ={this.state.isView} color ='orange' icon='save' content='Save Configuration' />}>
                        <Modal.Header>Are you sure?</Modal.Header>
                        <Modal.Content>
                            <p>
                              If your entries are in the correct format, the fields you've changed will be overwritten!
                              Please make sure any data you've entered is in the correct beofre confirming.
                            </p>
                        </Modal.Content>
                        <Modal.Actions>
                                <Button  icon ="checkmark" disabled ={this.state.isView}  positive size ={'tiny'} id = 'editNodes' onClick={this.handleEdit} content = {"Yes. I'm Sure"}/>
                        </Modal.Actions>
                    </Modal>
                    
            </Segment>
            </div>
            


        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(Node);



// WEBPACK FOOTER //
// ./src/components/node.js